module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_long_front.12ab9964.png";